export default __webpack_public_path__ + "static/banner-image-a-73497198c9ae08b125e2022a4689ef78.png";